import React from "react";
import { FormattedDate, FormattedTime, FormattedMessage } from "react-intl";
import moment from "moment";
import PhoneLink from "../../components/presentational/PhoneLink";
export function getScheduledPayment(acct) {
    return acct.payments.find(it => it.status === "Scheduled");
}
export function getRoutePaymentStatus(group, now = moment()) {
    if (!group.open) {
        return {
            paymentAllowed: false,
            message: (<FormattedMessage id="payment.utils.accountClosed" defaultMessage="Account has been closed with DCM Services"/>)
        };
    }
    for (const account of group.accounts) {
        if (!account.paymentEligible) {
            continue;
        }
        const { paymentAllowed, message } = getAcctPaymentStatus(account);
        if (!paymentAllowed) {
            return {
                paymentAllowed,
                message
            };
        }
    }
    if (group.paymentAllowedAt != null) {
        const paymentAllowedAt = moment(group.paymentAllowedAt);
        if (paymentAllowedAt.isAfter(now)) {
            const date = paymentAllowedAt.toDate();
            return {
                paymentAllowed: false,
                message: (<FormattedMessage id="payment.utils.recentPayment" defaultMessage={"Due to a recent payment, you are unable to make an additional payment "
                    + "until {date} at {time}."} values={{
                    date: <FormattedDate value={date}/>,
                    time: <FormattedTime value={date}/>
                }}/>)
            };
        }
    }
    return {
        paymentAllowed: true
    };
}
function getAcctPaymentStatus(acct) {
    if (acct.paymentPending) {
        return {
            paymentAllowed: false,
            message: (<FormattedMessage id="payment.utils.paymentPending" defaultMessage="A payment was recently made and is currently pending"/>)
        };
    }
    const scheduledPayment = getScheduledPayment(acct);
    if (scheduledPayment != null) {
        return {
            paymentAllowed: false,
            message: (<FormattedMessage id="payment.utils.futurePayment" defaultMessage={"If you would like to make a payment, please remove your payment currently "
                + "scheduled for a future date."}/>)
        };
    }
    if (!acct.allowPayment) {
        return {
            paymentAllowed: false,
            message: (<FormattedMessage id="payment.utils.notAllowed" defaultMessage={"Currently unable to make a payment on this account. Please contact us at "
                + "{phone} for more information"} values={{
                phone: <PhoneLink />
            }}/>)
        };
    }
    return {
        paymentAllowed: true
    };
}
export function showCancelDisclosure(date, now = moment()) {
    return date != null && date.diff(now) >= 24 * 60 * 60 * 1000;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/payment/paymentUtils.tsx